
import { Link } from "react-router-dom";
import { ChevronRight, Users } from "lucide-react";
import { Group } from "@/lib/types";

interface GroupHeaderProps {
  group: Group;
  memberCount: number;
}

export const GroupHeader = ({ group, memberCount }: GroupHeaderProps) => {
  return (
    <div className="mb-8">
      <div className="flex items-center mb-2">
        <Link to="/groups" className="text-muted-foreground hover:text-foreground transition-colors">
          Groups
        </Link>
        <ChevronRight className="h-4 w-4 mx-1 text-muted-foreground" />
        <span className="font-medium">{group.name}</span>
      </div>
      
      <div className="flex justify-between items-start">
        <div>
          <h1 className="text-3xl font-bold">{group.name}</h1>
          {group.description && (
            <p className="text-muted-foreground mt-1">{group.description}</p>
          )}
          <div className="flex items-center text-sm text-muted-foreground mt-3">
            <Users className="h-4 w-4 mr-1" />
            {memberCount} {memberCount === 1 ? "Member" : "Members"}
          </div>
        </div>
      </div>
    </div>
  );
};
